import {
  Box,
  Button,
  Grid,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import DisplayEmptyListAction from "../../../../../../components/DisplayEmptyListAction";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";

export default function ListVinculos({
  title,
  items,
  handleOpenDialog,
  handleDeleteItem,
  handleEditItem,
  emptyListMessage,
  linkButtonText,
  linkButtonIcon,
  categoriaPrincipal,
  setCategoriaPrincipal,
  disableEdit = false
}: ListVinculosProps) {
  
  const paddingStyle = { paddingLeft: 0, paddingRight: 0 };

  const handleStarClick = (id: number) => {
    setCategoriaPrincipal?.((prev) => (prev === id ? null : id));
  };

  return (
    <>
      <Grid size={{xs:12}} my={1}>
        <Stack
          direction={"row"}
          alignItems={"flex-start"}
          justifyContent={"space-between"}
        >
          <Typography variant="subtitle1" fontWeight={600}>
            {title}
          </Typography>
          {items.length > 0 && (
            <Button
              variant="outlined"
              size="small"
              onClick={handleOpenDialog}
              startIcon={linkButtonIcon}
              sx={{ textTransform: "none", paddingX: 3 }}
            >
              Adicionar
            </Button>
          )}
        </Stack>
      </Grid>
      {items.length > 0 && (
        <Grid size={{xs:12}}>
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={paddingStyle}>
                    <b>Nome</b>
                  </TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {items.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell sx={paddingStyle}>{item.nome}</TableCell>
                    <TableCell sx={paddingStyle}>
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="flex-end"
                      >
                        {handleEditItem && !disableEdit && (
                          <IconButton
                            aria-label="edit"
                            onClick={() => handleEditItem(item)}
                          >
                            <EditIcon />
                          </IconButton>
                        )}
                        {!handleEditItem && (
                          <IconButton
                            onClick={() => handleStarClick(item.id)}
                            color={
                              categoriaPrincipal === item.id
                                ? "warning"
                                : "default"
                            }
                          >
                            {categoriaPrincipal === item.id ? (
                              <StarIcon />
                            ) : (
                              <StarBorderIcon />
                            )}
                          </IconButton>
                        )}
                        <IconButton
                          aria-label="delete"
                          onClick={() => handleDeleteItem(item.id)}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      )}
      {items.length <= 0 && (
        <Grid size={{xs: 12}}>
          <DisplayEmptyListAction
            label={emptyListMessage}
            actionSection={
              <Stack direction="row" gap={2}>
                <Button
                  variant="outlined"
                  size="small"
                  startIcon={linkButtonIcon}
                  onClick={handleOpenDialog}
                  sx={{ mt: 1, textTransform: "none", paddingX: 3 }}
                >
                  {linkButtonText}
                </Button>
              </Stack>
            }
          />
        </Grid>
      )}
    </>
  );
}

interface ListVinculosProps {
  title: string;
  items: any[];
  handleOpenDialog: () => void;
  handleDeleteItem: (id: number) => void;
  handleEditItem?: (item: any) => void;
  emptyListMessage: string;
  linkButtonText: string;
  linkButtonIcon: React.ReactNode;
  categoriaPrincipal?: number | null;
  setCategoriaPrincipal?: React.Dispatch<React.SetStateAction<number | null>>;
  disableEdit?: boolean;
}
